var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path, _path2, _path3, _path4, _mask, _path5;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtlanticCanadaCapeIslanderContrast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 86,
    viewBox: "0 0 85 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 43.4131,
    r: 42.5,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30.0431,
    y: 22.3058,
    width: 1.57958,
    height: 26.0182,
    rx: 0.789792,
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 0.785443
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39.1094,
    y: 21.9131,
    width: 2.36503,
    height: 22.8619,
    rx: 1.18251,
    transform: "rotate(90 39.1094 21.9131)",
    fill: "#1E1E1E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37.1089,
    y: 27.7711,
    width: 27.0526,
    height: 14.8789,
    fill: "#1E1E1E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 37.1089,
    y: 34.5352,
    width: 33.8158,
    height: 14.8789,
    fill: "#1E1E1E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 39.8174,
    y: 37.2399,
    width: 5.41052,
    height: 5.41052,
    rx: 0.880471,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 39.8174,
    y: 29.1243,
    width: 21.6421,
    height: 4.05789,
    rx: 0.880471,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9326,
    y: 37.2399,
    width: 5.41052,
    height: 5.41052,
    rx: 0.880471,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 56.0479,
    y: 37.2399,
    width: 5.41052,
    height: 5.41052,
    rx: 0.880471,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 35.5146,
    y: 25.0663,
    width: 29.7579,
    height: 2.70526,
    rx: 0.880471,
    fill: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0586 52.1196C18.7154 53.2017 58.7533 45.3565 79.719 39.2697C77.0138 47.9265 73.6322 49.4144 65.5164 60.2354L13.4402 61.588C12.3581 59.4238 10.9603 56.8538 10.0586 52.1196Z",
    fill: "#1E1E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76687 48.3062L7.76674 48.3062C7.22197 48.328 6.72728 48.4301 6.3419 48.6342C5.9482 48.8426 5.64112 49.1764 5.57331 49.6428C5.50836 50.0897 5.67937 50.555 5.99757 51.0076C6.31908 51.4648 6.82309 51.9566 7.52015 52.4794C7.68021 52.5995 7.8929 52.6694 8.09879 52.717C8.31652 52.7674 8.58027 52.8042 8.88087 52.8305C9.48291 52.8832 10.2726 52.8971 11.2184 52.8778C13.1124 52.8392 15.6729 52.6663 18.6949 52.3859C24.7413 51.8248 32.6638 50.8302 40.8579 49.6034C49.0522 48.3766 57.5243 46.9167 64.6696 45.4242C71.797 43.9354 77.6538 42.4047 80.5822 41.0261C82.0788 40.3215 82.758 38.8793 82.3027 37.7234C82.0731 37.1407 81.57 36.6982 80.8551 36.5205C80.1515 36.3456 79.2607 36.4285 78.2086 36.8304C62.0444 43.0054 30.5209 47.4051 7.76687 48.3062Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 0.880471
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1152 48.7372C16.3696 51.6679 21.8252 57.2587 25.6126 56.1766C29.4 55.0945 31.6994 49.8644 32.3757 47.3845C34.4047 50.0898 35.5625 54.824 41.8441 54.824C47.3877 54.824 49.2836 47.3845 49.2836 45.3556",
    stroke: "white",
    strokeWidth: 0.880471,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.76 1.76"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5835 23.4897V30.5848",
    stroke: "#1E1E1E",
    strokeWidth: 0.785443,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-1_1_78890",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9927 33.7382C16.5827 33.7382 16.2433 34.0735 16.3201 34.4762C16.4185 34.9927 16.6198 35.4868 16.9147 35.9281C17.3478 36.5763 17.9634 37.0815 18.6836 37.3799C19.4039 37.6782 20.1964 37.7563 20.9611 37.6042C21.7257 37.4521 22.428 37.0767 22.9793 36.5254C23.5305 35.9742 23.906 35.2718 24.0581 34.5072C24.2101 33.7426 24.1321 32.95 23.8337 32.2298C23.5354 31.5095 23.0302 30.8939 22.382 30.4608C21.9407 30.1659 21.4466 29.9646 20.9301 29.8662C20.5273 29.7894 20.1921 30.1289 20.1921 30.5389C20.1921 30.9489 20.5318 31.2705 20.9232 31.3925C21.1467 31.4622 21.3603 31.5638 21.5571 31.6953C21.9612 31.9653 22.2761 32.349 22.462 32.798C22.648 33.2469 22.6967 33.7409 22.6019 34.2176C22.507 34.6942 22.273 35.132 21.9294 35.4756C21.5858 35.8192 21.148 36.0532 20.6714 36.148C20.1948 36.2428 19.7008 36.1941 19.2518 36.0082C18.8029 35.8222 18.4191 35.5073 18.1492 35.1032C18.0177 34.9065 17.9161 34.6929 17.8464 34.4693C17.7244 34.0779 17.4027 33.7382 16.9927 33.7382Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9927 33.7382C16.5827 33.7382 16.2433 34.0735 16.3201 34.4762C16.4185 34.9927 16.6198 35.4868 16.9147 35.9281C17.3478 36.5763 17.9634 37.0815 18.6836 37.3799C19.4039 37.6782 20.1964 37.7563 20.9611 37.6042C21.7257 37.4521 22.428 37.0767 22.9793 36.5254C23.5305 35.9742 23.906 35.2718 24.0581 34.5072C24.2101 33.7426 24.1321 32.95 23.8337 32.2298C23.5354 31.5095 23.0302 30.8939 22.382 30.4608C21.9407 30.1659 21.4466 29.9646 20.9301 29.8662C20.5273 29.7894 20.1921 30.1289 20.1921 30.5389C20.1921 30.9489 20.5318 31.2705 20.9232 31.3925C21.1467 31.4622 21.3603 31.5638 21.5571 31.6953C21.9612 31.9653 22.2761 32.349 22.462 32.798C22.648 33.2469 22.6967 33.7409 22.6019 34.2176C22.507 34.6942 22.273 35.132 21.9294 35.4756C21.5858 35.8192 21.148 36.0532 20.6714 36.148C20.1948 36.2428 19.7008 36.1941 19.2518 36.0082C18.8029 35.8222 18.4191 35.5073 18.1492 35.1032C18.0177 34.9065 17.9161 34.6929 17.8464 34.4693C17.7244 34.0779 17.4027 33.7382 16.9927 33.7382Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.57089,
    mask: "url(#path-15-inside-1_1_78890)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtlanticCanadaCapeIslanderContrast);
export default __webpack_public_path__ + "static/media/AtlanticCanadaCapeIslanderContrast.a6d630ff72fa4d409692ac0dd332d290.svg";
export { ForwardRef as ReactComponent };